import { useAdminAuth } from './AdminAuthContext';

export function usePermissions() {
  const { admin } = useAdminAuth();
  const perms = admin?.resolved_permissions ?? [];
  const has = (key) => perms.includes('*') || perms.includes(key);
  return { has, perms };
}
